import { Component, OnDestroy, OnInit } from '@angular/core';
import { Zooming } from '@3ddv/ngx-sites-builder-lib';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-zooming',
  templateUrl: './zooming.component.html',
  styleUrls: ['./zooming.component.scss']
})
export class ZoomingComponent implements OnInit, OnDestroy {
  private subscriptions: Array<Subscription>;
  public tool: Zooming;
  @Output() exportTool = new EventEmitter<Zooming>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.zooming){
        this.tool = JSON.parse(JSON.stringify(res.zooming));
      }else{
        console.error("zooming tool not found");
        return;
      }

    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }

  onSelect($event): void{
    this.exportTool.emit(this.tool);
  }

  public getTool(){
    return this.tool;
  }
}
